import $ from 'jquery';
import lax from 'lax.js'

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');

$(function () {

    if (inBackend) return;


    const scrollDistance = window.innerHeight * 0.6;
    const translationDistance = 200;
    const easing = 'easeOutCubic';


    lax.init();


    // Add a driver that we use to control our animations
    lax.addDriver('scrollY', function () {
        return window.scrollY;
    });

    lax.addElements('.assembly-fade', {
        scrollY: {
            opacity: [
                ["elInY", "elInY+" + scrollDistance],
                [0, 1],
                {easing: easing}
            ],
        }
    });

    lax.addElements('.assembly-from-left', {
        scrollY: {
            translateX: [
                ["elInY", "elInY+" + scrollDistance],
                [-translationDistance, 0],
                {easing: easing}
            ],
        }
    });

    lax.addElements('.assembly-from-right', {
        scrollY: {
            translateX: [
                ["elInY", "elInY+" + scrollDistance],
                [translationDistance, 0],
                {easing: easing}
            ],
        }
    });

    lax.addElements('.assembly-from-bottom', {
        scrollY: {
            translateY: [
                ["elInY", "elInY+" + scrollDistance],
                [translationDistance, 0],
                {easing: easing}
            ],
        }
    });



});
